import {getLayoutData, getPageData} from "@/pages/api/api";
import {
	RECAP_INFO_QUERY,
	RECAP_SUMMARY_ITEM_QUERY,
	SEE_ALSO_INFO_BLOCK_QUERY,
	SEO_QUERY,
	WHAT_WE_DO_CATEGORY_QUERY,
	WHAT_WE_DO_SINGLE_ACTION_QUERY
} from "@/pages/api/fragments";
import ExtendedContent from "@/components/common/ExtendedContent";
import {useSetBannerDataFromRecapContent} from "@/hooks/useSetBannerData";
import {formatContentWithRecap} from "@/utils/utils";
import Recap from "@/components/Recap";
import SubPageBanner from "@/components/Banners/SubPage/SubPageBanner";
import {CONTENT_TYPES, PAGES} from "@/constants";
import SeeAlso, {getSeeAlsoData} from "@/components/SeeAlso";
import {useMemo} from "react";

export default function WhatWeDo({data, locale, menu}) {
	const content = data?.content || []
	const bannerData = useSetBannerDataFromRecapContent(data)
	const formattedContent = formatContentWithRecap(content || []);
	const seeAlsoInfo = data?.seeAlsoInfo || { header: '', variant: ''}
	const formattedSeeAlsoData = useMemo(() => getSeeAlsoData(data),[data])

	// console.log(data)

	return (
		<>
			<SubPageBanner data={bannerData}/>
			<Recap/>
			<ExtendedContent content={formattedContent}/>
			<SeeAlso
				header={seeAlsoInfo.header}
				variant={seeAlsoInfo.variant}
				data={formattedSeeAlsoData}
			/>
		</>
	)
}

const GENERAL_WHAT_WE_DO_CATEGORY_QUERY = `
	query GetWhatWeDoCategoryData($locale: SiteLocale, $slug: String) {
		allWhatWeDoCategories(locale: $locale,  filter: {slug: {eq: $slug }}) {
			__typename
			pageName
			slug 
			${SEO_QUERY}
			recapInfo {
			 	${RECAP_INFO_QUERY}
			}
			isHorizontalAspect
			content {
				${RECAP_SUMMARY_ITEM_QUERY}
			}
			seeAlsoInfo{
				${SEE_ALSO_INFO_BLOCK_QUERY}
			}
			seeAlsoLinks {
				__typename
				... on ${CONTENT_TYPES.WHAT_WE_DO_SINGLE_ACTION} {
					${WHAT_WE_DO_SINGLE_ACTION_QUERY}
				}
				... on ${CONTENT_TYPES.WHAT_WE_DO_CATEGORY} {
					${WHAT_WE_DO_CATEGORY_QUERY}
				}
				... on ${CONTENT_TYPES.SINGLE_PAGE} {
					__typename
					id
					pageType
					slug
					card {
						header
						description
					}
				}
			}
		}
	}
`;


export async function getStaticProps(context) {
	const locale = context?.locale || 'pl';
	const data = await getPageData('allWhatWeDoCategories', PAGES.WHAT_WE_DO, GENERAL_WHAT_WE_DO_CATEGORY_QUERY, locale, 'wwd-props');
	const layout = await getLayoutData(locale)
	return {
		props: {
			data,
			locale,
			...layout,
			isDarkSearch: false
		},
		revalidate: 60 * 2
	};
}
